import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FLOW_TYPE } from '../../../framework/App/AppConstants';
import AnnouncementPopup from '../../../shared-components/AnnouncementPopup/AnnouncementPopup';
import './PaymentSecurityPage.less';
import { PYMT_SECURITY_CARD } from './PaymentSecurityPageConstants';
import Header from '../../components/Header/Header';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import PaymentSecurityProgramAgreementContent from './PaymentSecurityProgramAgreementContent';

export const PAYMENT_SECURITY_PROGRAM_AGREEMENT_URL = '/ppcreditapply/terms/payment-security-program-agreement.html';

export class PaymentSecurityProgramAgreementModal extends Component {
    static propTypes = {
        onClose: PropTypes.func,
        showAsModal: PropTypes.bool,
        onComponentDidMount: PropTypes.func.isRequired,
        flow: PropTypes.string.isRequired,
        onClickClose: PropTypes.func.isRequired,
    };

    static defaultProps = {
        onComponentDidMount: () => {}
    };

    componentDidMount() {
        this.props.onComponentDidMount(this.props);
    }

    handleCloseModal = event => {
        this.props.onClickClose(event);
    };

    getHeader() {
        const flow = this.props.flow;
        const defaultHeader = (
            <Header
                onCancel={this.handleCloseModal} singleColumnLayout={false}
            />
        );
        if (flow !== FLOW_TYPE.TESLA && flow !== FLOW_TYPE.VENICE) {
            return defaultHeader;
        }
        return '';
    }
    

    render() {
        const {
            onClose,
        } = this.props;

        return (
            <section id="PaymentSecurityProgramAgreement" className="PaymentSecurityProgramAgreement">
                <AnnouncementPopup
                    id="PaymentSecurityProgramAgreementPopup"
                    onClose={onClose}
                    showXButton={true}
                    stickyFooter={false}
                    showPPLogo={false}
                >
                    <PaymentSecurityProgramAgreementContent
                        htmlUri={PAYMENT_SECURITY_PROGRAM_AGREEMENT_URL}
                        iframeContainerQuerySelector="#PaymentSecurityProgramAgreementPopup"
                    />
                </AnnouncementPopup>
            </section>
        );
    }
}

export const mapDispatchToProps = dispatch => ({
    onComponentDidMount(props) {
        capeLog && capeLog('Loading payment security program agreement');
    },
    onClickClose() {
        dispatch(trackTransition('apply_pp_credit_paymentsecurity_programagreement', 'cancel_x_apply_pp_credit_paymentsecurity_programagreement'));
    }
});

const mapStateToProps = state => {
    const showAsModal = _.get(state, 'serverData.elmo.PaymentSecurity') === PYMT_SECURITY_CARD;
    return {
        flow: _.get(state, 'serverData.flow'),
        showAsModal,
        paymentSecurityExperiment: _.get(state, 'serverData.elmo.PaymentSecurity')
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSecurityProgramAgreementModal);
